import { Button } from './button';
import { Container } from './container';

export const components = {
  Button,
  Container,
};
